import React from 'react';
import { NavMenu } from './NavMenu';

export default props => (
    <div>
        <div>
            {/* <NavMenu /> */} 
        </div>
        <div className='container-fluid mt-3'>
            {props.children}
        </div>
    </div>
);



// WEBPACK FOOTER //
// ./src/components/Layout.js